@if (CompanyVendor) {
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-auto">
        <label class="fs-22">VIVE Review Progress</label>
      </div>
    </div>
    <div class="row row-padding justify-content-center">
      <div class="tracker-part-container col-md-11">
        <div class="row justify-content-center">
          <div class="col-2 d-flex flex-column">
            <div class="row justify-content-end flex-grow-1">
              <div class="col-auto d-flex flex-column">
                <div
                  class="flex-grow-1 tracker-bar {{
                    allowSelection ? 'selection' : ''
                  }}"
                  [ngClass]="getPaymentStatusClass()"
                ></div>
                <div
                  class="tracker-dot {{ allowSelection ? 'selection' : '' }}"
                  [ngClass]="getPaymentStatusClass()"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-10">
            <label
              class="tracker-label fw-normal {{
                allowSelection ? 'selection' : ''
              }}"
              [ngClass]="getPaymentStatusClass()"
              >Vendor Paid - {{ getPaymentInformation() }}</label
            >
          </div>
        </div>
      </div>
      @for (ComplianceStep of ComplianceSteps; track ComplianceStep) {
        <div class="tracker-part-container col-md-11">
          <div
            #progressDateTooltip="ngbTooltip"
            class="row justify-content-center"
            [ngbTooltip]="getProgressDate(ComplianceStep)"
            [autoClose]="false"
            triggers="manual"
            (mouseover)="progressDateTooltip.open()"
            (mouseleave)="progressDateTooltip.close()"
          >
            <div class="col-2 d-flex flex-column">
              <div class="row justify-content-end flex-grow-1">
                <div class="col-auto d-flex flex-column">
                  <div
                    class="flex-grow-1 tracker-bar {{
                      allowSelection ? 'selection' : ''
                    }}"
                    [ngClass]="getProgressStatusClass(ComplianceStep)"
                  ></div>
                  <div
                    class="tracker-dot {{ allowSelection ? 'selection' : '' }}"
                    [ngClass]="getProgressStatusClass(ComplianceStep)"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-10">
              @if (allowSelection) {
                <label
                  class="tracker-label fw-normal {{
                    allowSelection ? 'selection' : ''
                  }}"
                  [ngClass]="getProgressStatusClass(ComplianceStep)"
                  (click)="goToStep(ComplianceStep)"
                  >{{ getComplianceStepText(ComplianceStep) }}</label
                >
              }
              @if (!allowSelection) {
                <label
                  class="tracker-label fw-normal {{
                    allowSelection ? 'selection' : ''
                  }}"
                  [ngClass]="getProgressStatusClass(ComplianceStep)"
                  >{{ getComplianceStepText(ComplianceStep) }}</label
                >
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
